<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Arah Kebijakan Pembangunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="cek_sasaran_add" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                                    <i class="material-icons">add</i>
                                </button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">
                    <div class="col-md-6">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="getMisi()" v-model="filter_rpjmd" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <span class="huruf_input">Pilih Misi</span>
                        <select @change="getSasaran()" v-model="filter_misi" class="form-control" :disabled="filter_rpjmd==''">
                            <option value="" >-- Semua Misi --</option>
                              <option v-for="(data) in list_misi" :key="data.misi_id" v-bind:value="data.misi_id">	&#91;	{{data.no_misi}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>

                    <!-- <div class="col-md-4">
                        <span class="huruf_input">Pilih Sasaran</span>
                        <select @change="getData()" v-model="filter_sasaran" class="form-control" :disabled="filter_misi=='' || filter_rpjmd==''">
                            <option value="" >-- Semua Sasaran --</option>
                              <option v-for="(data) in list_sasaran" :key="data.sasaran_id" v-bind:value="data.sasaran_id">	&#91; {{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}} &#93;	{{data.uraian}}</option>
                        </select>
                    </div> -->

               </div>

        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <!-- <th class="tabel_center text-center" style="width: 5%">No.</th> -->
                            <th class="tabel_center text-center" style="width: 8%">Kode</th>
                            <th class="tabel_center text-center" style="width: 40%">Uraian Strategi</th>
                            <th class="tabel_center text-center" style="width: ">Keterangan</th>
                            <th class="tabel_center text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="4" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="data in list_data" :key="data.arah_kebijakan_id">
                                    <!-- <td class="tabel_center text-center">1.</td> -->
                                    <td class="tabel_center text-center">{{data.no_misi}}.{{data.no_arah_kebijakan}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="tabel_center text-justify">{{data.keterangan}}</td>

                                    <td class="tabel_center text-center" >
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.arah_kebijakan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                    
                                    <form @submit.prevent="addData()">
                                        <div class="modal-body">

                                            

                                            <div v-if="!cek_sasaran" class="text-center">
                                                <span> 
                                                    <i class="material-icons col-orange">warning</i> <br>
                                                    <b>MOHON PILIH MISI TERLEBIH DAHULU...!!!</b>
                                                </span>
                                            </div>

                                            <div v-if="cek_sasaran">
    
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Strategi</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="no_arah_kebijakan" type="number" min="1" class="form-control" placeholder="Nomor Sasaran">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian Strategi</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="modal-footer">
                                            


                                            <button v-if="!cek_sasaran" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            <button v-if="cek_sasaran" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button v-if="cek_sasaran" @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">


                                    <div>
                                        <table style="width: 100%" class="h_isitablex">
                                            <tr>
                                                <td style="width: 10%">Periode</td>
                                                <td style="width: 1%">:</td>
                                                <td>{{rpjmd_periode}}</td>
                                            </tr>

                                            <tr>
                                                <td>Misi</td>
                                                <td>:</td>
                                                <td>[{{no_misi}}] {{misi_uraian}}</td>
                                            </tr>

                                        </table>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Strategi</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_arah_kebijakan" type="number" min="1" class="form-control" placeholder="Nomor Strategi">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Strategi</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Keterangan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_SASARAN = URL_APP+'api/v1/planning_sasaran_pembangunan/';
  
    const ADD_URL = URL_APP+'api/v1/planning_arah_kebijakan/';


    export default {
        name: "planning_urusan",
        data() {
            return {

   
                filter_rpjmd: '',
                filter_misi: '',
                filter_sasaran : '',


                cek_sasaran : false,

                rpjmd_id : '',
                rpjmd_periode : '',

                misi_id : '',
                no_misi : '',
                misi_uraian : '',

                sasaran_id : '',
                no_sasaran : '',
                sasaran_uraian : '',

                arah_kebijakan_id : '',
                no_arah_kebijakan : 0,
                uraian : '',
                keterangan : '',

                list_data: [],
                list_rpjmd: [],
                list_misi: [],
                list_sasaran : [],
                

                pilih_sasaran : [],


                cek_sasaran : false,




                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            }
        },

        mounted() {
            this.getData();
            this.getPeriode();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getPeriode: function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },

                }).then(res => res.json()).then((res_data)=>{
                    //   console.log(res_data);
                    this.list_rpjmd = res_data
                })


            },

            getMisi: function(){
                if (this.filter_rpjmd == '') {
                    this.filter_misi = '';
                    this.filter_sasaran = '';
                }
                fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.filter_rpjmd
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_misi = res_data
                        this.getData();

                        
                })
            },

            getSasaran: function(){
                if (this.filter_misi == '') {
                    this.filter_sasaran = '';
                }
                fetch(ADD_URL_SASARAN+'sasaran_in_arah_kebijakan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        misi_id : this.filter_misi
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_sasaran = res_data
                        this.getData();

                        
                })
            },

            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        rpjmd_id : this.filter_rpjmd,
                        misi_id : this.filter_misi,
                        sasaran_id : this.filter_sasaran,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data);
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    this.cek_load_data = false;
                })
            },


            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        misi_id : this.filter_misi,
                        sasaran_id : this.filter_sasaran,
                        no_arah_kebijakan : this.no_arah_kebijakan,
                        uraian : this.uraian,
                        keterangan : this.keterangan,

                    })
                }).then(res => res.json()).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            
            editData: function(){
                fetch(ADD_URL+'editData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        misi_id : this.misi_id,
                        arah_kebijakan_id : this.arah_kebijakan_id,
                        no_arah_kebijakan : this.no_arah_kebijakan,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },


            selectData : function(data){
                this.rpjmd_id = data.rpjmd_id;
                this.rpjmd_periode = data.rpjmd_periode;

                this.misi_id = data.misi_id;
                this.no_misi = data.no_misi;
                this.misi_uraian = data.misi_uraian;

                this.arah_kebijakan_id = data.arah_kebijakan_id;
                this.no_arah_kebijakan = data.no_arah_kebijakan;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.data = data;

            },
            removeData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            arah_kebijakan_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },

            emptyData : function(){
                this.list_indikator = [];
                // this.list_sasaran =[];
                this.pilih_sasaran =[];
            },

            cek_sasaran_add : function(){
                if (this.filter_misi == '') {
                    this.cek_sasaran = false;
                }else{
                    this.cek_sasaran = true;
                }
            },

            //PAGINASI
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                    this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getData();
                },

                btn_next : function(){
                    this.cek_load_data = true;
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getData();
                },

                cari_data : function(){
                    this.cek_load_data = true;
                    this.page_first = 1;
                    this.getData();
                }

            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
